import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import axiosInstance from 'axiosConfig';
import { Toast } from 'components';
import { TOAST_TYPES_ENUM } from 'enums';
import { queryClient } from 'App';

type AddAssemblyMaterialType = {
  cost: any;
  name: string;
  supplierUuid: string;

};

const useAddAssemblyMaterial = (
  options?: UseMutationOptions<any, Error, AddAssemblyMaterialType>
) => {
  return useMutation({
    ...options,
    mutationKey: ['addAssemblyMaterial'],
    mutationFn: async ({ cost, name, supplierUuid }) => {
      return axiosInstance.post('/assembly-materials', {
        cost,
        supplierUuid,
        name,
      }).then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: 'Przetwarzanie żądania dodania materiału montażowego...',
        type: TOAST_TYPES_ENUM.LOADING,
        id: 'add-assembly-material',
      });
      if (options && options.onMutate) {
        return options.onMutate(variables);
      }
    },
    onSuccess: async(data, variables, context) => {
      Toast({
        message: 'Materiał montażowy dodany pomyślnie.',
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: 'add-assembly-material',
      });
       await queryClient.invalidateQueries({ queryKey: ['assemblyMaterials'] });
      if (options && options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error, variables, context) => {
      Toast({
        message: 'Błąd podczas dodawania materiału montażowego.',
        type: TOAST_TYPES_ENUM.ERROR,
        id: 'add-assembly-material',
      });
      if (options && options.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};

export default useAddAssemblyMaterial;
